import { useState } from "react";
import SectionTitle from "./common/SectionTitle";
import { CLINICS } from "../constants/data";
import { scrollTo } from "../utils/scroll";
import { useInView } from "../hooks/useInView";

export default function Clinics() {
  const [activeClinic, setActiveClinic] = useState(0);
  const [clinicRef, clinicVis] = useInView();

  const generateMapEmbedUrl = (lat: number, lng: number) => {
    return `https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3671.5554471282326!2d${lng}!3d${lat}!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0:0x0!2z${lat}%2C${lng}!5e0!3m2!1sen!2sin!4v1234567890`;
  };

  return (
    <div id="clinics" style={{ padding: "80px 20px", background: "white" }}>
      <div style={{ maxWidth: 1100, margin: "0 auto" }}>
        <SectionTitle
          tag="Visit Us"
          title="Our Clinic Locations"
          sub="Two convenient locations across Ahmedabad for your kidney care needs"
        />

        <div
          style={{
            display: "flex",
            gap: 12,
            justifyContent: "center",
            marginBottom: 40,
          }}
        >
          {CLINICS.map((clinic, i) => (
            <button
              key={i}
              onClick={() => setActiveClinic(i)}
              style={{
                padding: "10px 24px",
                borderRadius: 50,
                border: "none",
                fontSize: 14,
                fontWeight: 600,
                cursor: "pointer",
                transition: "all 0.2s",
                background: activeClinic === i ? "#1d4ed8" : "#f1f5f9",
                color: activeClinic === i ? "white" : "#475569",
                boxShadow:
                  activeClinic === i ? "0 4px 14px rgba(29,78,216,0.3)" : "none",
              }}
            >
              {i + 1}. {clinic.name.split(" ")[0]} {clinic.name.split(" ")[1]}
            </button>
          ))}
        </div>

        <div
          ref={clinicRef}
          style={{
            opacity: clinicVis ? 1 : 0,
            transform: clinicVis ? "translateY(0)" : "translateY(30px)",
            transition: "all 0.7s ease",
          }}
        >
          {CLINICS.map((clinic, i) => (
            <div
              key={i}
              style={{
                display: activeClinic === i ? "grid" : "none",
                gridTemplateColumns: "1fr 1fr",
                gap: 28,
              }}
            >
              {/* Left Section: Info Cards */}
              <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>
                <div
                  style={{
                    background: `linear-gradient(135deg,${
                      i === 0 ? "#1d4ed8,#1e40af" : "#0d9488,#0f766e"
                    })`,
                    borderRadius: 24,
                    padding: "36px 32px",
                    color: "white",
                    boxShadow: "0 12px 40px rgba(0,0,0,0.15)",
                  }}
                >
                  <div style={{ fontSize: 40, marginBottom: 16 }}>🏥</div>
                  <h3 style={{ fontSize: 22, fontWeight: 700, marginBottom: 12 }}>
                    {clinic.name}
                  </h3>
                  <p
                    style={{
                      color: "rgba(255,255,255,0.8)",
                      fontSize: 14,
                      marginBottom: 10,
                      lineHeight: 1.6,
                    }}
                  >
                    📍 {clinic.address}
                  </p>
                  <p
                    style={{
                      color: "rgba(255,255,255,0.8)",
                      fontSize: 14,
                      marginBottom: 28,
                    }}
                  >
                    📞 {clinic.phone}
                  </p>
                  <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
                    <a
                      href={clinic.mapLink}
                      target="_blank"
                      rel="noreferrer"
                      style={{
                        background: "rgba(255,255,255,0.2)",
                        border: "1px solid rgba(255,255,255,0.3)",
                        color: "white",
                        fontWeight: 600,
                        fontSize: 13,
                        padding: "10px 20px",
                        borderRadius: 50,
                        cursor: "pointer",
                        textDecoration: "none",
                        display: "inline-block",
                        transition: "background 0.2s",
                      }}
                      onMouseEnter={(e) => {
                        (e.currentTarget as HTMLAnchorElement).style.background =
                          "rgba(255,255,255,0.3)";
                      }}
                      onMouseLeave={(e) => {
                        (e.currentTarget as HTMLAnchorElement).style.background =
                          "rgba(255,255,255,0.2)";
                      }}
                    >
                      🗺 Get Directions
                    </a>
                    <button
                      onClick={() => scrollTo("contact")}
                      style={{
                        background: "white",
                        color: i === 0 ? "#1d4ed8" : "#0d9488",
                        fontWeight: 700,
                        fontSize: 13,
                        padding: "10px 20px",
                        borderRadius: 50,
                        border: "none",
                        cursor: "pointer",
                        transition: "opacity 0.2s",
                      }}
                      onMouseEnter={(e) => {
                        (e.currentTarget as HTMLButtonElement).style.opacity = "0.9";
                      }}
                      onMouseLeave={(e) => {
                        (e.currentTarget as HTMLButtonElement).style.opacity = "1";
                      }}
                    >
                      Book Here
                    </button>
                  </div>
                </div>

                {/* Timings Card */}
                <div
                  style={{
                    background: "#f8fafc",
                    borderRadius: 24,
                    padding: "36px 32px",
                    border: "1px solid #e2e8f0",
                  }}
                >
                  <h4
                    style={{
                      fontWeight: 700,
                      color: "#1e293b",
                      marginBottom: 20,
                      fontSize: 16,
                    }}
                  >
                    🕐 Clinic Timings
                  </h4>
                  <div>
                    {clinic.timings.map((timing, j) => (
                      <div
                        key={j}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          padding: "12px 0",
                          borderBottom:
                            j < clinic.timings.length - 1
                              ? "1px solid #e2e8f0"
                              : "none",
                        }}
                      >
                        <span
                          style={{
                            color: "#475569",
                            fontSize: 14,
                            fontWeight: 500,
                          }}
                        >
                          {timing.day}
                        </span>
                        <span
                          style={{
                            fontSize: 13,
                            fontWeight: 600,
                            padding: "4px 14px",
                            borderRadius: 50,
                            background:
                              timing.time === "Closed" ? "#fee2e2" : "#f0fdf9",
                            color: timing.time === "Closed" ? "#dc2626" : "#0d9488",
                          }}
                        >
                          {timing.time}
                        </span>
                      </div>
                    ))}
                  </div>
                  <div
                    style={{
                      marginTop: 20,
                      padding: "14px 16px",
                      background: "#fffbeb",
                      borderRadius: 14,
                      border: "1px solid #fde68a",
                    }}
                  >
                    <p
                      style={{
                        color: "#92400e",
                        fontSize: 12,
                        fontWeight: 500,
                      }}
                    >
                      ⚠️ Timings may vary on public holidays. Please call ahead to
                      confirm your appointment.
                    </p>
                  </div>
                </div>
              </div>

              {/* Right Section: Google Map */}
              <div
                style={{
                  borderRadius: 24,
                  overflow: "hidden",
                  boxShadow: "0 12px 40px rgba(0,0,0,0.15)",
                  background: "#f0f0f0",
                  minHeight: 500,
                }}
              >
                <iframe
                  title={`${clinic.name} Location Map`}
                  style={{
                    width: "100%",
                    height: "100%",
                    border: "none",
                    minHeight: 500,
                  }}
                  src={`https://www.google.com/maps?q=${clinic.coordinates.lat},${clinic.coordinates.lng}&hl=en&z=15&output=embed`}
                  allowFullScreen={true}
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
